import { v4 } from 'uuid';

export function geoJsonToPolygons(geoJson) {
  const geometry = geoJson.geometry || geoJson;
  const coordToLatLng = ([lng, lat]) => ({ lat, lng });
  const isMultiPolygon = geometry.type === 'MultiPolygon';
  const { coordinates } = geometry;
  const polygons = isMultiPolygon ? coordinates : [coordinates];

  return polygons.map((polygonCoordinates) => {
    const paths = polygonCoordinates.map((coords) => coords.map(coordToLatLng));
    return new window.google.maps.Polygon({ paths });
  });
}

export function polygonToFeature(polygon, id = v4()) {
  const latLngToLiteral = (ll) => ({ lat: ll.lat(), lng: ll.lng() });
  const pathToLatLng = (path) => path.getArray().map(latLngToLiteral);
  const coordinates = polygon.getPaths().getArray().map(pathToLatLng);

  return new window.google.maps.Data.Feature({
    id,
    geometry: new window.google.maps.Data.Polygon(coordinates),
    properties: { id },
  });
}

export async function polygonToGeoJson(polygon) {
  const layer = new window.google.maps.Data();
  layer.add(polygonToFeature(polygon));

  return new Promise((resolve) => {
    layer.toGeoJson(({ features }) => resolve(features[0]));
  });
}

export function polylineToGeoJson(polyline) {
  return {
    type: 'LineString',
    coordinates: polyline
      .getPath()
      .getArray()
      .map((latLng) => [latLng.lng(), latLng.lat()]),
  };
}

export function addListener(...args) {
  return window.google.maps.event.addListener(...args);
}

export function removeListener(...args) {
  return window.google.maps.event.removeListener(...args);
}
